import React from "react";
import {useParams, NavLink} from "react-router";
import {ArrowBackIos} from "@mui/icons-material";
import {Button, Paper, Stack, Box, Typography} from "@mui/material";
import ScopeGroupName from "../../components/scopeGroup/ScopeGroupDetail/ScopeGroupName.tsx";
import {useLocationFormState} from "../../components/scopeGroup/ScopeGroupForm/ScopeGroupUpdateForm";
import ScopeGroupUpdateFormProvider from "../../components/scopeGroup/ScopeGroupForm/ScopeGroupUpdateFormProvider";
import {useTitle} from 'react-use';
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const ScopeGroupUpdateEditPage = () => {
    
    useTitle(t`Update Scope Group`);

    const { scopeGroupId: id } = useParams();
    
    return (
        <Box data-testid="ScopeGroup-update-form">
            <Paper sx={ { padding: "2em" } }>
                <Stack direction="column" spacing={1}>
                    <Typography
                        sx={ { flex: '1 1 100%' } }
                        variant="h6"
                        component="div"
                        data-testid="ScopeGroup-update-title"
                    >
                        <Trans>Edit Scope Group</Trans>:  <ScopeGroupName id={id}/>
                    </Typography>
                    <ScopeGroupUpdateFormProvider
                        id={id}
                        cancelButton={
                            <Button size="medium" variant="contained" color="inherit" startIcon={<ArrowBackIos />}
                                    component={NavLink}
                                    to=".."
                                    relative="path"
                                    viewTransition={true}
                            >
                                <Trans>Cancel</Trans>
                            </Button>
                        }
                        initialFormState={useLocationFormState}
                    />
                </Stack>
            </Paper>
        </Box>
    )
}

export default ScopeGroupUpdateEditPage;
